import { BrandLogo } from '@components/logos/brandLogo/BrandLogo';
import { Result, theme } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdOutlineDesktopWindows } from 'react-icons/md';

import Button from '../chaosComponents/button/Button';
import useIsMobileScreen from './hooks/useIsMobileScreen';

function MobileWarningScreen() {
  const { t } = useTranslation('common', { keyPrefix: 'components' });

  const isMobile = useIsMobileScreen();
  const [dismissed, setDismissed] = useState(false);
  const { token } = theme.useToken();

  if (!isMobile || dismissed) return null;

  return (
    <div
      className="flex-center flex-column mh-100vh"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: token.colorBgContainer,
      }}
    >
      <div
        className="flex-center"
        style={{ position: 'absolute', top: 56, left: 0, right: 0 }}
      >
        <BrandLogo size={64} wrapperClassName="flex-center" />
      </div>
      <Result
        icon={<MdOutlineDesktopWindows size={48} color="var(--color-accent)" />}
        title={t('mobileWarningTitle')}
        subTitle={t('mobileWarningSubTitle')}
        extra={
          <div className="flex-center">
            <Button
              type="primary"
              label={t('mobileWarningCtaBtn')}
              onClick={() => setDismissed(true)}
            />
          </div>
        }
      />
    </div>
  );
}

export default MobileWarningScreen;
